import type { LayerRef } from '../store/types';
import type { AgentStep } from './loop';

/** If a successful tool step targets a specific node, return it for a flash. */
export function flashTargetFromStep(step: AgentStep): LayerRef | null {
  if (!step.ok) return null;
  const frameId = step.input.frameId;
  const cfNodeId = step.input.cfNodeId;
  if (typeof frameId === 'string' && typeof cfNodeId === 'string' && frameId && cfNodeId) {
    return { frameId, cfNodeId };
  }
  return null;
}
